import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-submit-button",
    styleUrls: ["./submit-button.component.scss"],
    templateUrl: "./submit-button.component.html"
})
export class FUISubmitButtonComponent extends FUIButtonComponent {

}
